import { IGoal } from 'motw_core/Entity/IGoal';
import * as React from 'react';
import { ClickGoal } from 'source/app/presentation/MainPanel/Goals/GoalCards/Helpers/ClickGoal';
import Hyperlink from 'source/app/presentation/Shared/Link/Hyperlink';
import { StyleClass } from 'source/app/presentation/Shared/Styles/CSS';

export function GoalName({
	goal,
	isGoalBleeding
}: {
	goal: IGoal;
	isGoalBleeding: boolean;
}) {
	const styleClass = StyleClass(`goalName_${isGoalBleeding}`, {
		fontSize: '10px',
		width: '100%',
		position: 'relative',
		bottom: '57px',
		color: 'white',
		top: '-15px',
		background: isGoalBleeding ? `darkred` : '#1b1b1b',
		opacity: 0.8,
		padding: `0px 5px`
	});
	
	return (
		<Hyperlink whenClicked={() => ClickGoal(goal)} title={goal.name}>
			<div
				id="goalName"
				className={styleClass}
			>
				{goal.name.slice(0, 7)}
			</div>
		</Hyperlink>
	);
}
